import { render, staticRenderFns } from "./WidgetTransferStats.vue?vue&type=template&id=2a22afe0&scoped=true"
import script from "./WidgetTransferStats.vue?vue&type=script&lang=js"
export * from "./WidgetTransferStats.vue?vue&type=script&lang=js"
import style0 from "./WidgetTransferStats.vue?vue&type=style&index=0&id=2a22afe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a22afe0",
  null
  
)

export default component.exports